import { onMounted, ref } from 'vue'

interface UsePrintDataOptions<TData> {
  loadMockData: () => Promise<TData>
}

export function usePrintData<TData>({ loadMockData }: UsePrintDataOptions<TData>) {
  const data = ref<TData | null>(null)

  onMounted(async () => {
    if (window.__PDF_DATA__) {
      data.value = window.__PDF_DATA__ as unknown as TData
    } else if (import.meta.env.DEV) {
      console.warn('No injected data found. Loading local mock data...')
      data.value = await loadMockData()
    }

    document.body.appendChild(document.createElement('div')).id = 'print-ready'
  })

  return {
    data,
  }
}
